import { queryReleases } from '@/features/releases/data';
import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { QueryResult, ReleaseListItemDto } from '@flowqa/shared';

export const fetchReleasesGrid = async (
  projectId?: string | null,
  orgId?: string | null,
  input?: GridQueryInput,
): Promise<QueryResult<ReleaseListItemDto>> => {
  const resolvedInput: GridQueryInput = input ?? {
    page: 1,
    pageSize: 50,
    sorts: [{ field: 'createdAt', direction: 'desc' }],
    filters: [],
  };
  return await queryReleases(projectId ?? undefined, orgId ?? undefined, {
    ...resolvedInput,
    include: {
      project: true,
      features: { ids: true, items: true },
      suites: { ids: true, items: true },
      tests: { ids: true, items: true },
      latestSuiteResults: { counts: true },
      latestTestResults: { counts: true },
    },
  });
};
